import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ze-page-not-found-view',
  templateUrl: './page-not-found-view.component.html',
  styleUrls: ['./page-not-found-view.component.scss']
})
export class PageNotFoundViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
